var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoweredByAaneel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 35,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 54.8855,
    cy: 62.4547,
    fx: 54.8855,
    fy: 62.4547,
    r: 19.3321,
    gradientTransform: "translate(-16.2684 -34.821) rotate(2.9062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#f7941d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#f15a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#dd5124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4854,
    stopColor: "#c1441e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#b7401c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5961,
    stopColor: "#ad3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6749,
    stopColor: "#942e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7745,
    stopColor: "#6b190a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#3e0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0.2843,
    cy: 28.2308,
    fx: 0.2843,
    fy: 28.2308,
    r: 25.2886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f95d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2921,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3081,
    stopColor: "#196fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4202,
    stopColor: "#0b4c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5036,
    stopColor: "#033658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#002e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6556,
    stopColor: "#00203a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8738,
    stopColor: "#00081e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 9.1951,
    cy: 30.4992,
    fx: 9.1951,
    fy: 30.4992,
    r: 14.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#f7941d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#f15a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#dd5124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4854,
    stopColor: "#c1441e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#b7401c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5961,
    stopColor: "#ad3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6749,
    stopColor: "#942e14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7745,
    stopColor: "#6b190a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#3e0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 27.0825,
    cy: 17.8064,
    fx: 27.0825,
    fy: 17.8064,
    r: 18.6511,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 16.6672,
    cy: 17.8064,
    fx: 16.6672,
    fy: 17.8064,
    r: 18.6732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#40b6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#2f95d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    stopColor: "#14629e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#094570"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#023354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#002d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    stopColor: "#001934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 65.109,
    y1: 26.2339,
    x2: 67.4745,
    y2: 29.0889,
    gradientTransform: "translate(-42.3725 -6.0806) rotate(-2.3728)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 55.8057,
    y1: 24.6938,
    x2: 56.5037,
    y2: 25.5363,
    gradientTransform: "translate(-42.3725 -6.0805) rotate(-2.3728)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 79.6116,
    cy: -9.3849,
    fx: 79.6116,
    fy: -9.3849,
    r: 3.0424,
    gradientTransform: "translate(57.3467 93.17) rotate(-89.851)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#aee2fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1956,
    stopColor: "#00a7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4438,
    stopColor: "#1b6aae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#194f8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#194680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#0d2657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7338,
    stopColor: "#030a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#000025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8204,
    stopColor: "#000228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8562,
    stopColor: "#020a33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#051845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9227,
    stopColor: "#0a2c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9545,
    stopColor: "#10457e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9853,
    stopColor: "#1764a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c75bc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.4131,30.4795s.3995,2.4718,2.6264,3.3959c.1574.0666-.0306-.2313.1429-.1829l.8089-.4263,10.3312-16.4883s-1.1719,1.1876-3.1935.367c-.9398-.3836-1.5877-1.3361-1.5877-1.3361l-9.1281,14.6707Z",
    fill: "url(#b)",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.3553,27.4334l5.9691-9.4824s3.9902-4.8839,8.0523.9646c0,0-2.8712-1.1567-6.1591,4.4919l-5.8239,9.4772s-2.7077,4.3657-8.3936.458c0,0,2.3264-.4272,3.5409-1.7141.5236-.5538,2.3734-3.4545,2.8144-4.1953Z",
    fill: "url(#c)",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.7618,27.4571l5.9715-9.4822s3.9902-4.8841,8.0528.9644c0,0-2.8721-1.1565-6.1576,4.4894l-5.7958,9.456s-2.7104,4.363-8.3952.458c0,0,2.3271-.4272,3.5438-1.7141.522-.5538,2.343-3.4281,2.7805-4.1715Z",
    fill: "url(#d)",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.7389,17.9774s2.232-.5486,3.7151,3.0164l4.968,11.2432s.885,2.7652,3.6471,2.763c1.6101,0,2.3727-.3337,3.9441-1.7615,0,0-1.9093-.7054-2.6263-2.0844-.2832-.5466-.7909-1.6908-.7909-1.6908,0,0-1.9138-4.1872-2.506-5.4951-.539-1.1871-1.4765-3.7158-2.1111-4.8796-.7314-1.3459-2.8549-4.1935-6.0238-2.9028-.8929.3598-1.5372.8564-2.2162,1.7917Z",
    fill: "url(#e)",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12.3078,17.9774s2.2339-.5486,3.7174,3.0164l4.9684,11.2432s.8834,2.7652,3.644,2.763c1.6118,0,2.4309-.3739,4.0038-1.7991,0,0-1.8339-.4656-2.5514-1.8456-.284-.5484-.9235-1.8921-.9235-1.8921,0,0-1.9116-4.1872-2.5045-5.4951-.5374-1.1871-1.4765-3.7158-2.1113-4.8796-.7309-1.3459-2.8562-4.1935-6.0232-2.9028-.8924.3598-1.5367.8564-2.2197,1.7917Z",
    fill: "url(#f)",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.2343,17.7094s3.6484-4.4001,7.4832,1.0912l4.8177,10.7216s-1.927,3.5529.117,5.2066c0,0-2.6018.3677-3.5033-1.7441,0,0-3.6871-8.1624-6.1207-13.246-.9197-1.9218-2.2291-1.9152-2.7939-2.0294Z",
    fill: "url(#g)",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m12.7535,17.7332s3.4834-4.4576,7.3901,1.1344l.2297.4844s-1.1411,8.1789-3.4402,3.268c-.4645-.993-.9168-1.9502-1.3352-2.8185-.9377-1.9581-2.2687-1.9534-2.8444-2.0683Z",
    fill: "url(#h)",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m47.5721,11.9631c1.3408.002,2.4246,1.0939,2.4204,2.4381-.0032,1.3401-1.0934,2.4248-2.4358,2.4197-1.3408-.0027-2.4266-1.0914-2.4224-2.4349.0047-1.3415,1.0934-2.4277,2.4378-2.4228Z",
    fill: "url(#i)",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m48.586,13.4836c0,.1498-.17.2648-.3809.2648-.2105-.0027-.3804-.1221-.3786-.2648,0-.1458.1693-.2655.3786-.2635.2109.002.3809.1203.3809.2635Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m48.0158,13.7937c0,.0483-.0566.0832-.1261.0832-.0684,0-.1239-.0349-.1219-.0832,0-.0481.0535-.0863.1239-.0863.0676,0,.1241.0382.1241.0863Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m58.1361,20.2723c1.8755,0,3.4733.5327,4.7931,1.5977,1.3189,1.0655,1.9786,2.3481,1.9786,3.8489v5.7738c0,.2178-.1149.4022-.3453.5533-.2299.1512-.5086.2272-.8346.2272-.3275,0-.6088-.076-.8443-.2272-.2364-.1512-.3545-.3355-.3545-.5533v-2.9231h-6.4447c-.3268,0-.6081-.0787-.8445-.2362-.2355-.1575-.3538-.3449-.3538-.5627s.1183-.4053.3538-.5623c.2364-.1579.5178-.2366.8445-.2366h6.4447v-1.2529c0-1.065-.4292-1.9726-1.2887-2.7228-.8595-.7505-1.8941-1.1261-3.1043-1.1261s-2.2453.3755-3.1048,1.1261c-.8592.7501-1.2891,1.6577-1.2891,2.7228v5.7917c0,.2178-.1147.4053-.3449.5632-.2302.157-.5084.2357-.8351.2357-.339,0-.6233-.0787-.8535-.2357-.2299-.1579-.3449-.3453-.3449-.5632v-5.7917c0-1.5007.6629-2.7834,1.9878-3.8489,1.3256-1.065,2.92-1.5977,4.7844-1.5977Z",
    fill: "#1c75bc",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m66.2645,27.662c0-1.3191.5841-2.445,1.752-3.3772,1.168-.9322,2.5751-1.3983,4.2212-1.3983s3.0533.4661,4.2212,1.3983c1.1679.9322,1.7521,2.0581,1.7521,3.3772v3.8307c0,.2178-.1181.4022-.3543.5533-.2357.1512-.5171.2272-.8445.2272-.3261,0-.6047-.076-.8347-.2272-.2303-.1512-.3453-.3355-.3453-.5533v-3.8307c0-.8835-.3511-1.6376-1.0529-2.2607-.7018-.6231-1.5495-.9349-2.5416-.9349s-1.8402.3118-2.5416.9349c-.7018.6231-1.0534,1.3772-1.0534,2.2607,0,.8713.3516,1.6188,1.0534,2.2419.7014.6231,1.5495.9353,2.5416.9353.411,0,.8172-.0608,1.2162-.1821.1696-.0599.3449-.0903.5265-.0903.2661,0,.5296.0693.7899.2084.2598.1391.3905.3359.3905.5905,0,.3265-.2178.5627-.6535.7081-.7259.2415-1.4828.3632-2.2696.3632-1.6461,0-3.0533-.4693-4.2212-1.4077-1.1679-.938-1.752-2.0603-1.752-3.3673Z",
    fill: "#1c75bc",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m79.7507,25.6831c0-3.4856,1.307-5.2285,3.9215-5.2285,1.3191,0,2.4812.7618,3.4859,2.2869.6535,1.0048,1.1737,2.2032,1.5611,3.5952.3024,1.1013.717,2.118,1.2439,3.0502.526.9317.9711,1.434,1.3343,1.5065.5202,0,.929-.3149,1.2252-.9438.2966-.6293.4451-1.4891.4451-2.5783v-6.1549c0-.2178.1181-.4053.3538-.5625.2366-.157.5175-.2364.8445-.2364.3265,0,.6052.0794.8351.2364.2299.1572.3444.3446.3444.5625v6.1549c0,3.4013-1.3491,5.1015-4.0481,5.1015-1.3191,0-2.4571-.7559-3.4134-2.2692-.6052-.9442-1.1075-2.1363-1.5065-3.5762-.3028-1.1022-.7354-2.1211-1.2985-3.0593-.5622-.9382-1.0319-1.4432-1.4068-1.5159-.4719,0-.8472.3294-1.1259.989-.2782.6595-.4178,1.5403-.4178,2.642v5.8096c0,.2178-.115.4022-.3444.5533-.2299.1512-.5086.2272-.8351.2272-.3386,0-.6231-.076-.8539-.2272-.2295-.1512-.3444-.3355-.3444-.5533v-5.8096Z",
    fill: "#1c75bc",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m96.7939,27.662c0-1.3191.5837-2.445,1.7516-3.3772,1.1679-.9322,2.5756-1.3983,4.2212-1.3983,1.2592,0,2.4025.2878,3.4313.8629,1.0293.5752,1.7553,1.3285,2.1784,2.2598.0725.1699.1096.3395.1096.5086,0,.5207-.2724.8231-.8172.9085l-6.3907,1.0521c-.0971.0125-.1932.0188-.2903.0188-.2787,0-.5332-.0608-.7626-.1816-.2908-.1574-.4357-.3632-.4357-.6173,0-.4115.3024-.6656.9076-.7627l5.1561-.8351c-.7018-1.0892-1.7311-1.634-3.0864-1.634-.9921,0-1.8398.3118-2.5416.9349-.7018.6231-1.0529,1.3772-1.0529,2.2607,0,.8713.3511,1.6188,1.0529,2.2419.7018.6231,1.5495.9353,2.5416.9353,1.2708,0,2.2692-.4786,2.9952-1.4345.2183-.2903.5694-.4356,1.0539-.4356.1937,0,.3748.0246.5439.0725.4356.1454.6535.3811.6535.7085,0,.1329-.042.2537-.1266.3632-.5448.726-1.2677,1.2945-2.1695,1.7056-.9017.412-1.8854.6182-2.9504.6182-1.6456,0-3.0533-.4693-4.2212-1.4077-1.1679-.938-1.7516-2.0603-1.7516-3.3673Z",
    fill: "#1c75bc",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m109.4803,27.662c0-1.3191.5842-2.445,1.7521-3.3772,1.1679-.9322,2.5756-1.3983,4.2212-1.3983,1.2591,0,2.4025.2878,3.4317.8629,1.0283.5752,1.7547,1.3285,2.1783,2.2598.0729.1699.1087.3395.1087.5086,0,.5207-.2724.8231-.8168.9085l-6.3906,1.0521c-.0971.0125-.1937.0188-.2908.0188-.2782,0-.5327-.0608-.7622-.1816-.2907-.1574-.4356-.3632-.4356-.6173,0-.4115.3024-.6656.9076-.7627l5.1561-.8351c-.7019-1.0892-1.7311-1.634-3.0864-1.634-.9921,0-1.8398.3118-2.5416.9349-.7018.6231-1.0529,1.3772-1.0529,2.2607,0,.8713.3511,1.6188,1.0529,2.2419.7019.6231,1.5495.9353,2.5416.9353,1.2708,0,2.2696-.4786,2.996-1.4345.2178-.2903.5685-.4356,1.0521-.4356.1941,0,.3757.0246.5457.0725.4356.1454.6535.3811.6535.7085,0,.1329-.0429.2537-.1275.3632-.5448.726-1.2677,1.2945-2.1694,1.7056-.9018.412-1.8854.6182-2.9504.6182-1.6456,0-3.0533-.4693-4.2212-1.4077-1.1679-.938-1.7521-2.0603-1.7521-3.3673Z",
    fill: "#1c75bc",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m122.6212,21.2163c0-.2178.115-.4053.3453-.5625.2299-.157.5144-.2364.853-.2364.327,0,.6052.0794.8351.2364.2299.1572.3453.3446.3453.5625v10.2763c0,.2178-.1154.4022-.3453.5533-.2299.1512-.5081.2272-.8351.2272-.3386,0-.6231-.076-.853-.2272-.2303-.1512-.3453-.3355-.3453-.5533v-10.2763Z",
    fill: "#1c75bc",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m64.0977,6.6475v3.3398h-1.125V1.4561h3.1465c.9336,0,1.665.2383,2.1943.7148s.7939,1.1074.7939,1.8926c0,.8281-.2588,1.4658-.7764,1.9131s-1.2588.6709-2.2236.6709h-2.0098Zm0-.9199h2.0215c.6016,0,1.0625-.1416,1.3828-.4258.3203-.2832.4805-.6934.4805-1.2295,0-.5088-.1602-.9155-.4805-1.2207s-.7598-.4639-1.3184-.4756h-2.0859v3.3516Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m70.0098,6.7588c0-.6211.1221-1.1797.3662-1.6758s.584-.8789,1.0195-1.1484.9326-.4043,1.4912-.4043c.8633,0,1.5615.2988,2.0947.8965s.7998,1.3926.7998,2.3848v.0762c0,.6172-.1182,1.1709-.3545,1.6611s-.5742.8721-1.0137,1.1455-.9443.4102-1.5146.4102c-.8594,0-1.5557-.2988-2.0889-.8965s-.7998-1.3887-.7998-2.373v-.0762Zm1.0898.1289c0,.7031.1631,1.2676.4893,1.6934s.7627.6387,1.3096.6387c.5508,0,.9883-.2158,1.3125-.6475s.4863-1.0361.4863-1.8135c0-.6953-.165-1.2588-.4951-1.6904s-.7686-.6475-1.3154-.6475c-.5352,0-.9668.2129-1.2949.6387s-.4922,1.0352-.4922,1.8281Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m82.7539,8.4932l1.2188-4.8457h1.084l-1.8457,6.3398h-.8789l-1.541-4.8047-1.5,4.8047h-.8789l-1.8398-6.3398h1.0781l1.248,4.7461,1.4766-4.7461h.873l1.5059,4.8457Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m88.7891,10.1045c-.8594,0-1.5586-.2822-2.0977-.8467s-.8086-1.3193-.8086-2.2646v-.1992c0-.6289.1201-1.1904.3604-1.6846s.5762-.8809,1.0078-1.1602.8994-.4189,1.4033-.4189c.8242,0,1.4648.2715,1.9219.8145s.6855,1.3203.6855,2.332v.4512h-4.2949c.0156.625.1982,1.1299.5479,1.5146s.7939.5771,1.333.5771c.3828,0,.707-.0781.9727-.2344s.498-.3633.6973-.6211l.6621.5156c-.5312.8164-1.3281,1.2246-2.3906,1.2246Zm-.1348-5.6836c-.4375,0-.8047.1592-1.1016.4775s-.4805.7646-.5508,1.3389h3.1758v-.082c-.0312-.5508-.1797-.9775-.4453-1.2803s-.625-.4541-1.0781-.4541Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m95.5801,4.6201c-.1641-.0273-.3418-.041-.5332-.041-.7109,0-1.1934.3027-1.4473.9082v4.5h-1.084V3.6475h1.0547l.0176.7324c.3555-.5664.8594-.8496,1.5117-.8496.2109,0,.3711.0273.4805.082v1.0078Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m99.207,10.1045c-.8594,0-1.5586-.2822-2.0977-.8467s-.8086-1.3193-.8086-2.2646v-.1992c0-.6289.1201-1.1904.3604-1.6846s.5762-.8809,1.0078-1.1602.8994-.4189,1.4033-.4189c.8242,0,1.4648.2715,1.9219.8145s.6855,1.3203.6855,2.332v.4512h-4.2949c.0156.625.1982,1.1299.5479,1.5146s.7939.5771,1.333.5771c.3828,0,.707-.0781.9727-.2344s.498-.3633.6973-.6211l.6621.5156c-.5312.8164-1.3281,1.2246-2.3906,1.2246Zm-.1348-5.6836c-.4375,0-.8047.1592-1.1016.4775s-.4805.7646-.5508,1.3389h3.1758v-.082c-.0312-.5508-.1797-.9775-.4453-1.2803s-.625-.4541-1.0781-.4541Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m102.6699,6.7646c0-.9727.2305-1.7549.6914-2.3467s1.0645-.8877,1.8105-.8877c.7422,0,1.3301.2539,1.7637.7617V.9873h1.084v9h-.9961l-.0527-.6797c-.4336.5312-1.0371.7969-1.8105.7969-.7344,0-1.333-.3008-1.7959-.9023s-.6943-1.3867-.6943-2.3555v-.082Zm1.084.123c0,.7188.1484,1.2812.4453,1.6875s.707.6094,1.2305.6094c.6875,0,1.1895-.3086,1.5059-.9258v-2.9121c-.3242-.5977-.8223-.8965-1.4941-.8965-.5312,0-.9453.2051-1.2422.6152s-.4453,1.0176-.4453,1.8223Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m112.8418,9.9873V1.4561h2.7891c.9258,0,1.6221.1914,2.0889.5742s.7002.9492.7002,1.6992c0,.3984-.1133.751-.3398,1.0576s-.5352.5439-.9258.7119c.4609.1289.8252.374,1.0928.7354s.4014.792.4014,1.292c0,.7656-.248,1.3672-.7441,1.8047s-1.1973.6562-2.1035.6562h-2.959Zm1.125-4.8926h1.6992c.4922,0,.8857-.123,1.1807-.3701.2949-.2466.4424-.5811.4424-1.0039,0-.4697-.1367-.8115-.4102-1.0244-.2734-.2134-.6895-.3203-1.248-.3203h-1.6641v2.7188Zm0,.9023v3.0703h1.8574c.5234,0,.9365-.1357,1.2393-.4072s.4541-.6455.4541-1.1221c0-1.0273-.5586-1.541-1.6758-1.541h-1.875Z",
    fill: "#696969",
    strokeWidth: 0
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m122.2168,8.3994l1.4766-4.752h1.1602l-2.5488,7.3184c-.3945,1.0547-1.0215,1.582-1.8809,1.582l-.2051-.0176-.4043-.0762v-.8789l.293.0234c.3672,0,.6533-.0742.8584-.2227s.374-.4199.5068-.8145l.2402-.6445-2.2617-6.2695h1.1836l1.582,4.752Z",
    fill: "#696969",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByAaneel);
export default __webpack_public_path__ + "static/media/powered-by-aaneel.835c538d1d55436c0a0f44c04306c695.svg";
export { ForwardRef as ReactComponent };